import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../constants';
import { formatQueryParams } from '../helperFunctions';
import type { MapperItemConfig } from './types';

export const getContentPagePath = ({ slug, source }: MapperItemConfig) => {
    const params: Record<string, any> = { article_id: slug };
    return pathfinder(PATHFINDER.CONTENT_PAGE, params, formatQueryParams({ source }));
};
